module.exports = "/packs/images/svg/arrow-down~073757d7fe6fec7cf8593f8ed472aa43.svg";